import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import logger from "../../utils/LoggerFrontend.js";
import Actions from "../../Actions.js";
import { CampaignContextProvider } from "../../context/Campaign.context.jsx";

import CampaignCreatePreviews from "../../PagesUser/SelfServiceCampaignCreation/Previews/campaign-create-previews/CampaignCreatePreviews.jsx";
import { InfoBanner } from "../../PagesUser/SelfServiceCampaignCreation/Previews/Components/index.js";
import { URLEditor, StatusWindow, ClientPanel } from "./Components/index.js";
import { withRefluxStore, PreviewStore, MediaLibraryStore } from "../../Stores/index.js";
import { CampaignCreatePreviewsWrapper, ErrorMessage } from "./PublicCreativesView.styled.js";

const PublicCreativesView = ({
  match: {
    params: { campaignId, adsetId }
  },
  location: { search },
  released,
  channelsData,
  campaignData
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get token from query params
  const params = new URLSearchParams(search);
  const token = params.get("token");

  logger.log("PublicCreativesView", "PublicCreativesView data", { campaignId, adsetId, token });

  // Step 1. Fetch the campaign data
  useEffect(() => {
    if (!token) {
      setError("Invalid link. Please contact the person who shared this link with you.");
      setLoading(false);
      return;
    }

    const ref = Actions.loadSharedCampaignData.completed.listen(({ payload }) => {
      logger.log("AdPreviewTool", "loadSharedCampaignData campaign loaded", { payload });
      ref();
      setLoading(false);
      setError(null);
    });

    const refFailed = Actions.loadSharedCampaignData.failed.listen((error) => {
      logger.error("AdPreviewTool", "loadSharedCampaignData unable to load campaign", { error });
      setError("Invalid or expired link. Please contact the person who shared this link with you.");
      setLoading(false);
      refFailed();
    });

    Actions.loadSharedCampaignData(campaignId, token);

    return () => {
      ref?.();
      refFailed?.();
    };
  }, [campaignId, token]);

  // Helpers
  const { organizationId: orgaId, deployed } = campaignData || {};

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (
      <ErrorMessage>
        <h2>Access Error</h2>
        <p>{error}</p>
      </ErrorMessage>
    );
  }

  return (
    <CampaignContextProvider>
      <CampaignCreatePreviewsWrapper>
        {!deployed && <InfoBanner status="stagingWarning" top="62px" />}
        <CampaignCreatePreviews
          editable={false}
          orgaId={orgaId}
          tbCampaignId={campaignId}
          tbAdsetId={adsetId}
          showLinkEditor={false}
        >
          <ClientPanel
            campaignId={campaignId}
            orgaId={campaignData.organizationId}
            userProfile={{}}
            orgaName={campaignData.orgaName}
            campaignManager={campaignData.campaignManager}
            startDate={campaignData.startDate}
            source={campaignData.source}
            jobUpdatesUrl={campaignData.jobUpdatesUrl}
            duration={campaignData?.campaignDuration}
            adsetId={adsetId}
          />
          <StatusWindow startDate={campaignData.startDate} />
          <URLEditor
            campaignData={campaignData}
            editable={false}
            channelsData={channelsData}
            released={released}
            campaignId={campaignId}
          />
        </CampaignCreatePreviews>
      </CampaignCreatePreviewsWrapper>
    </CampaignContextProvider>
  );
};

export default withRefluxStore(
  withRouter(PublicCreativesView),
  [PreviewStore, MediaLibraryStore],
  ["posts", "released", "loading", "campaignData", "channelsData", "campaignManagers"]
);
